// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__21H59","titleSection":"header_titleSection__3UXkJ","selectSection":"header_selectSection__2UO_D"};